module.exports = __webpack_public_path__ + "static/img/color.54a187c6.jpg";